import { jsxs as r, jsx as e } from "react/jsx-runtime";
function o(t) {
  return /* @__PURE__ */ r("svg", { fill: "none", height: "30", viewBox: "0 0 93 30", width: "93", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
    /* @__PURE__ */ e("g", { filter: "url(#filter0_dd_2812_59964)", children: /* @__PURE__ */ e("path", { d: "M83 21.3496L83 5.86993L90 5.86993L87.9 13.6098L90 21.3496L83 21.3496Z", fill: "#2968FF" }) }),
    /* @__PURE__ */ e("g", { filter: "url(#filter1_dd_2812_59964)", children: /* @__PURE__ */ e("path", { d: "M10 5.86914L10 21.3488L3 21.3488L5.1 13.609L3 5.86914L10 5.86914Z", fill: "#2968FF" }) }),
    /* @__PURE__ */ e("g", { filter: "url(#filter2_dd_2812_59964)", children: /* @__PURE__ */ e("rect", { fill: "#2968FF", height: "23.2195", rx: "4", width: "75", x: "9", y: "2" }) }),
    /* @__PURE__ */ e(
      "path",
      {
        d: "M15.3576 10H11.7976V17H13.2376V14.2H13.9976L15.0076 17H16.4676L15.3876 14.1L16.4376 13.04V11.09L15.3576 10ZM14.7076 11.44L15.0076 11.74V12.67L14.7076 12.97H13.2376V11.44H14.7076ZM22.3619 10H17.9519V17H22.3719V15.57H19.3919V13.97H21.4519V12.86H19.3919V11.44H22.3619V10ZM27.2751 10H24.8951L23.6451 11.25V15.7C24.0751 16.14 24.5151 16.57 24.9451 17H27.2251L28.3551 15.87V14.22H26.9251V15.25C26.8151 15.36 26.7051 15.46 26.6051 15.57H25.4651L25.0851 15.18V11.81L25.4451 11.44H26.6251L26.9251 11.74V12.64H28.3551V11.09L27.2751 10ZM34.5213 11.17L33.3513 10H30.8913L29.7213 11.17V15.79L30.9413 17H33.2913L34.5213 15.79V11.17ZM33.0813 11.77V15.21L32.7313 15.57H31.5113L31.1613 15.21V11.77L31.4913 11.44H32.7413L33.0813 11.77ZM41.6653 10H40.0553L38.8853 12.36L37.7253 10H35.9753V17H37.3353V11.94L38.5253 14.25H39.1053L40.2953 11.94V17H41.6653V10ZM48.8939 10H47.2839L46.1139 12.36L44.9539 10H43.2039V17H44.5639V11.94L45.7539 14.25H46.3339L47.5239 11.94V17H48.8939V10ZM54.8424 10H50.4324V17H54.8524V15.57H51.8724V13.97H53.9324V12.86H51.8724V11.44H54.8424V10ZM61.1056 10H59.8756V14.27L57.8456 10H56.2156V17H57.4456V12.43L59.7056 17H61.1056V10ZM67.3831 11.42L65.9631 10H62.6531V17H65.9131L67.3831 15.53V11.42ZM65.4431 11.44L65.9431 11.94V15.05L65.4231 15.57H64.0931V11.44H65.4431ZM73.2467 10H68.8367V17H73.2567V15.57H70.2767V13.97H72.3367V12.86H70.2767V11.44H73.2467V10ZM79.3499 11.42L77.9299 10H74.6199V17H77.8799L79.3499 15.53V11.42ZM77.4099 11.44L77.9099 11.94V15.05L77.3899 15.57H76.0599V11.44H77.4099Z",
        fill: "#F6F7F7"
      }
    ),
    /* @__PURE__ */ r("defs", { children: [
      /* @__PURE__ */ r(
        "filter",
        {
          colorInterpolationFilters: "sRGB",
          filterUnits: "userSpaceOnUse",
          height: "21.4805",
          id: "filter0_dd_2812_59964",
          width: "13",
          x: "80",
          y: "3.86914",
          children: [
            /* @__PURE__ */ e("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feOffset", { dy: "1" }),
            /* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "BackgroundImageFix", mode: "normal", result: "effect1_dropShadow_2812_59964" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feMorphology", { in: "SourceAlpha", operator: "dilate", radius: "1", result: "effect2_dropShadow_2812_59964" }),
            /* @__PURE__ */ e("feOffset", {}),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "effect1_dropShadow_2812_59964", mode: "normal", result: "effect2_dropShadow_2812_59964" }),
            /* @__PURE__ */ e("feBlend", { in: "SourceGraphic", in2: "effect2_dropShadow_2812_59964", mode: "normal", result: "shape" })
          ]
        }
      ),
      /* @__PURE__ */ r(
        "filter",
        {
          colorInterpolationFilters: "sRGB",
          filterUnits: "userSpaceOnUse",
          height: "21.4805",
          id: "filter1_dd_2812_59964",
          width: "13",
          x: "0",
          y: "3.86914",
          children: [
            /* @__PURE__ */ e("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feOffset", { dy: "1" }),
            /* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "BackgroundImageFix", mode: "normal", result: "effect1_dropShadow_2812_59964" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feMorphology", { in: "SourceAlpha", operator: "dilate", radius: "1", result: "effect2_dropShadow_2812_59964" }),
            /* @__PURE__ */ e("feOffset", {}),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "effect1_dropShadow_2812_59964", mode: "normal", result: "effect2_dropShadow_2812_59964" }),
            /* @__PURE__ */ e("feBlend", { in: "SourceGraphic", in2: "effect2_dropShadow_2812_59964", mode: "normal", result: "shape" })
          ]
        }
      ),
      /* @__PURE__ */ r(
        "filter",
        {
          colorInterpolationFilters: "sRGB",
          filterUnits: "userSpaceOnUse",
          height: "29.2188",
          id: "filter2_dd_2812_59964",
          width: "81",
          x: "6",
          y: "0",
          children: [
            /* @__PURE__ */ e("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feOffset", { dy: "1" }),
            /* @__PURE__ */ e("feGaussianBlur", { stdDeviation: "1.5" }),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.15 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "BackgroundImageFix", mode: "normal", result: "effect1_dropShadow_2812_59964" }),
            /* @__PURE__ */ e(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                result: "hardAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              }
            ),
            /* @__PURE__ */ e("feMorphology", { in: "SourceAlpha", operator: "dilate", radius: "1", result: "effect2_dropShadow_2812_59964" }),
            /* @__PURE__ */ e("feOffset", {}),
            /* @__PURE__ */ e("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.2471 0 0 0 0 0.2471 0 0 0 0 0.2667 0 0 0 0.05 0" }),
            /* @__PURE__ */ e("feBlend", { in2: "effect1_dropShadow_2812_59964", mode: "normal", result: "effect2_dropShadow_2812_59964" }),
            /* @__PURE__ */ e("feBlend", { in: "SourceGraphic", in2: "effect2_dropShadow_2812_59964", mode: "normal", result: "shape" })
          ]
        }
      )
    ] })
  ] });
}
export {
  o as default
};
